"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IconAdjustments: function() {
        return IconAdjustments;
    },
    IconAdjustmentsHorizontal: function() {
        return IconAdjustmentsHorizontal;
    },
    IconAlertCircle: function() {
        return IconAlertCircle;
    },
    IconAlertTriangle: function() {
        return IconAlertTriangle;
    },
    IconAlignCenter: function() {
        return IconAlignCenter;
    },
    IconAlignJustified: function() {
        return IconAlignJustified;
    },
    IconAlignLeft: function() {
        return IconAlignLeft;
    },
    IconAlignRight: function() {
        return IconAlignRight;
    },
    IconArchive: function() {
        return IconArchive;
    },
    IconArrowBackUp: function() {
        return IconArrowBackUp;
    },
    IconArrowDown: function() {
        return IconArrowDown;
    },
    IconArrowForwardUp: function() {
        return IconArrowForwardUp;
    },
    IconArrowLeft: function() {
        return IconArrowLeft;
    },
    IconArrowRight: function() {
        return IconArrowRight;
    },
    IconArrowUp: function() {
        return IconArrowUp;
    },
    IconArrowsMaximize: function() {
        return IconArrowsMaximize;
    },
    IconArrowsMinimize: function() {
        return IconArrowsMinimize;
    },
    IconArrowsSort: function() {
        return IconArrowsSort;
    },
    IconBan: function() {
        return IconBan;
    },
    IconBell: function() {
        return IconBell;
    },
    IconBellOff: function() {
        return IconBellOff;
    },
    IconBold: function() {
        return IconBold;
    },
    IconBookmark: function() {
        return IconBookmark;
    },
    IconBookmarkOff: function() {
        return IconBookmarkOff;
    },
    IconBrandFacebook: function() {
        return IconBrandFacebook;
    },
    IconBrandInstagram: function() {
        return IconBrandInstagram;
    },
    IconBrandLinkedin: function() {
        return IconBrandLinkedin;
    },
    IconBrandTwitter: function() {
        return IconBrandTwitter;
    },
    IconBrandX: function() {
        return IconBrandX;
    },
    IconCalendar: function() {
        return IconCalendar;
    },
    IconCalendarEvent: function() {
        return IconCalendarEvent;
    },
    IconCamera: function() {
        return IconCamera;
    },
    IconCameraPlus: function() {
        return IconCameraPlus;
    },
    IconCaretDown: function() {
        return IconCaretDown;
    },
    IconCaretLeft: function() {
        return IconCaretLeft;
    },
    IconCaretRight: function() {
        return IconCaretRight;
    },
    IconCaretUp: function() {
        return IconCaretUp;
    },
    IconCheck: function() {
        return IconCheck;
    },
    IconChevronDown: function() {
        return IconChevronDown;
    },
    IconChevronLeft: function() {
        return IconChevronLeft;
    },
    IconChevronRight: function() {
        return IconChevronRight;
    },
    IconChevronUp: function() {
        return IconChevronUp;
    },
    IconCircle0: function() {
        return IconCircle0;
    },
    IconCircle1: function() {
        return IconCircle1;
    },
    IconCircle2: function() {
        return IconCircle2;
    },
    IconCircle3: function() {
        return IconCircle3;
    },
    IconCircle4: function() {
        return IconCircle4;
    },
    IconCircle5: function() {
        return IconCircle5;
    },
    IconCircle6: function() {
        return IconCircle6;
    },
    IconCircle7: function() {
        return IconCircle7;
    },
    IconCircle8: function() {
        return IconCircle8;
    },
    IconCircle9: function() {
        return IconCircle9;
    },
    IconCircleCheck: function() {
        return IconCircleCheck;
    },
    IconCircleCheckFilled: function() {
        return IconCircleCheckFilled;
    },
    IconCircleMinus: function() {
        return IconCircleMinus;
    },
    IconCirclePlus: function() {
        return IconCirclePlus;
    },
    IconCircleX: function() {
        return IconCircleX;
    },
    IconClock: function() {
        return IconClock;
    },
    IconCloud: function() {
        return IconCloud;
    },
    IconCloudDownload: function() {
        return IconCloudDownload;
    },
    IconCloudOff: function() {
        return IconCloudOff;
    },
    IconCloudUpload: function() {
        return IconCloudUpload;
    },
    IconCode: function() {
        return IconCode;
    },
    IconCoin: function() {
        return IconCoin;
    },
    IconCreditCard: function() {
        return IconCreditCard;
    },
    IconCurrentLocation: function() {
        return IconCurrentLocation;
    },
    IconDeviceDesktop: function() {
        return IconDeviceDesktop;
    },
    IconDeviceMobile: function() {
        return IconDeviceMobile;
    },
    IconDeviceTablet: function() {
        return IconDeviceTablet;
    },
    IconDots: function() {
        return IconDots;
    },
    IconDotsVertical: function() {
        return IconDotsVertical;
    },
    IconDownload: function() {
        return IconDownload;
    },
    IconEdit: function() {
        return IconEdit;
    },
    IconExternalLink: function() {
        return IconExternalLink;
    },
    IconEye: function() {
        return IconEye;
    },
    IconEyeOff: function() {
        return IconEyeOff;
    },
    IconFile: function() {
        return IconFile;
    },
    IconFileDownload: function() {
        return IconFileDownload;
    },
    IconFileExport: function() {
        return IconFileExport;
    },
    IconFileImport: function() {
        return IconFileImport;
    },
    IconFileSearch: function() {
        return IconFileSearch;
    },
    IconFileUpload: function() {
        return IconFileUpload;
    },
    IconFiles: function() {
        return IconFiles;
    },
    IconFilter: function() {
        return IconFilter;
    },
    IconFingerprint: function() {
        return IconFingerprint;
    },
    IconFlag: function() {
        return IconFlag;
    },
    IconFolder: function() {
        return IconFolder;
    },
    IconFolderOff: function() {
        return IconFolderOff;
    },
    IconFolderPlus: function() {
        return IconFolderPlus;
    },
    IconFolderX: function() {
        return IconFolderX;
    },
    IconH1: function() {
        return IconH1;
    },
    IconH2: function() {
        return IconH2;
    },
    IconH3: function() {
        return IconH3;
    },
    IconH4: function() {
        return IconH4;
    },
    IconH5: function() {
        return IconH5;
    },
    IconH6: function() {
        return IconH6;
    },
    IconHash: function() {
        return IconHash;
    },
    IconHeart: function() {
        return IconHeart;
    },
    IconHelp: function() {
        return IconHelp;
    },
    IconInbox: function() {
        return IconInbox;
    },
    IconInfoCircle: function() {
        return IconInfoCircle;
    },
    IconItalic: function() {
        return IconItalic;
    },
    IconLayout: function() {
        return IconLayout;
    },
    IconLetterT: function() {
        return IconLetterT;
    },
    IconLink: function() {
        return IconLink;
    },
    IconList: function() {
        return IconList;
    },
    IconListNumbers: function() {
        return IconListNumbers;
    },
    IconLocation: function() {
        return IconLocation;
    },
    IconLock: function() {
        return IconLock;
    },
    IconLockOpen: function() {
        return IconLockOpen;
    },
    IconLogin: function() {
        return IconLogin;
    },
    IconLogout: function() {
        return IconLogout;
    },
    IconMail: function() {
        return IconMail;
    },
    IconMailOpened: function() {
        return IconMailOpened;
    },
    IconMap: function() {
        return IconMap;
    },
    IconMapPin: function() {
        return IconMapPin;
    },
    IconMarkdown: function() {
        return IconMarkdown;
    },
    IconMenu2: function() {
        return IconMenu2;
    },
    IconMessage: function() {
        return IconMessage;
    },
    IconMicrophone: function() {
        return IconMicrophone;
    },
    IconMicrophoneOff: function() {
        return IconMicrophoneOff;
    },
    IconMusic: function() {
        return IconMusic;
    },
    IconPaperclip: function() {
        return IconPaperclip;
    },
    IconPencil: function() {
        return IconPencil;
    },
    IconPhone: function() {
        return IconPhone;
    },
    IconPhoneIncoming: function() {
        return IconPhoneIncoming;
    },
    IconPhoneOff: function() {
        return IconPhoneOff;
    },
    IconPhoneOutgoing: function() {
        return IconPhoneOutgoing;
    },
    IconPhoto: function() {
        return IconPhoto;
    },
    IconPin: function() {
        return IconPin;
    },
    IconPinnedOff: function() {
        return IconPinnedOff;
    },
    IconPlayerPause: function() {
        return IconPlayerPause;
    },
    IconPlayerPlay: function() {
        return IconPlayerPlay;
    },
    IconPlayerRecord: function() {
        return IconPlayerRecord;
    },
    IconPlayerSkipBack: function() {
        return IconPlayerSkipBack;
    },
    IconPlayerSkipForward: function() {
        return IconPlayerSkipForward;
    },
    IconPlayerStop: function() {
        return IconPlayerStop;
    },
    IconPlayerTrackNext: function() {
        return IconPlayerTrackNext;
    },
    IconPlayerTrackPrev: function() {
        return IconPlayerTrackPrev;
    },
    IconPlus: function() {
        return IconPlus;
    },
    IconRadiusBottomLeft: function() {
        return IconRadiusBottomLeft;
    },
    IconRefresh: function() {
        return IconRefresh;
    },
    IconSearch: function() {
        return IconSearch;
    },
    IconSelector: function() {
        return IconSelector;
    },
    IconSend: function() {
        return IconSend;
    },
    IconSettings: function() {
        return IconSettings;
    },
    IconShare: function() {
        return IconShare;
    },
    IconShield: function() {
        return IconShield;
    },
    IconShoppingCart: function() {
        return IconShoppingCart;
    },
    IconSourceCode: function() {
        return IconSourceCode;
    },
    IconStar: function() {
        return IconStar;
    },
    IconStrikethrough: function() {
        return IconStrikethrough;
    },
    IconTag: function() {
        return IconTag;
    },
    IconThumbDown: function() {
        return IconThumbDown;
    },
    IconThumbUp: function() {
        return IconThumbUp;
    },
    IconTrash: function() {
        return IconTrash;
    },
    IconUnderline: function() {
        return IconUnderline;
    },
    IconUpload: function() {
        return IconUpload;
    },
    IconUser: function() {
        return IconUser;
    },
    IconUserCircle: function() {
        return IconUserCircle;
    },
    IconUsers: function() {
        return IconUsers;
    },
    IconVideo: function() {
        return IconVideo;
    },
    IconVideoOff: function() {
        return IconVideoOff;
    },
    IconVolume: function() {
        return IconVolume;
    },
    IconVolume2: function() {
        return IconVolume2;
    },
    IconVolume3: function() {
        return IconVolume3;
    },
    IconWorld: function() {
        return IconWorld;
    },
    IconX: function() {
        return IconX;
    },
    IconZoomIn: function() {
        return IconZoomIn;
    },
    IconZoomOut: function() {
        return IconZoomOut;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
var _iconsreact = _interop_require_wildcard(require("@tabler/icons-react"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var withIcon = function(Component, props, ref) {
    var _props;
    var styles = (0, _react1.useStyleConfig)("Icon", {
        size: (_props = props) === null || _props === void 0 ? void 0 : _props.size
    });
    return _react.default.createElement(_react1.Icon, _object_spread_props(_object_spread({}, styles, props), {
        ref: ref
    }), _react.default.createElement(Component, null));
};
var IconAdjustments = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAdjustments, props, ref);
});
var IconAdjustmentsHorizontal = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAdjustmentsHorizontal, props, ref);
});
var IconAlertCircle = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlertCircle, props, ref);
});
var IconAlertTriangle = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlertTriangle, props, ref);
});
var IconAlignCenter = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlignCenter, props, ref);
});
var IconAlignJustified = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlignJustified, props, ref);
});
var IconAlignLeft = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlignLeft, props, ref);
});
var IconAlignRight = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconAlignRight, props, ref);
});
var IconArchive = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArchive, props, ref);
});
var IconArrowBackUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowBackUp, props, ref);
});
var IconArrowDown = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowDown, props, ref);
});
var IconArrowForwardUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowForwardUp, props, ref);
});
var IconArrowLeft = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowLeft, props, ref);
});
var IconArrowRight = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowRight, props, ref);
});
var IconArrowUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowUp, props, ref);
});
var IconArrowsMaximize = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowsMaximize, props, ref);
});
var IconArrowsMinimize = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowsMinimize, props, ref);
});
var IconArrowsSort = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconArrowsSort, props, ref);
});
var IconBan = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBan, props, ref);
});
var IconBell = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBell, props, ref);
});
var IconBellOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBellOff, props, ref);
});
var IconBold = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBold, props, ref);
});
var IconBookmark = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBookmark, props, ref);
});
var IconBookmarkOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBookmarkOff, props, ref);
});
var IconBrandFacebook = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBrandFacebook, props, ref);
});
var IconBrandInstagram = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBrandInstagram, props, ref);
});
var IconBrandLinkedin = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBrandLinkedin, props, ref);
});
var IconBrandTwitter = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBrandTwitter, props, ref);
});
var IconBrandX = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconBrandX, props, ref);
});
var IconCalendar = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCalendar, props, ref);
});
var IconCalendarEvent = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCalendarEvent, props, ref);
});
var IconCamera = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCamera, props, ref);
});
var IconCameraPlus = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCameraPlus, props, ref);
});
var IconCaretDown = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCaretDown, props, ref);
});
var IconCaretLeft = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCaretLeft, props, ref);
});
var IconCaretRight = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCaretRight, props, ref);
});
var IconCaretUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCaretUp, props, ref);
});
var IconCheck = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCheck, props, ref);
});
var IconChevronDown = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconChevronDown, props, ref);
});
var IconChevronLeft = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconChevronLeft, props, ref);
});
var IconChevronRight = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconChevronRight, props, ref);
});
var IconChevronUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconChevronUp, props, ref);
});
var IconCircle0 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber0, props, ref);
});
var IconCircle1 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber1, props, ref);
});
var IconCircle2 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber2, props, ref);
});
var IconCircle3 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber3, props, ref);
});
var IconCircle4 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber4, props, ref);
});
var IconCircle5 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber5, props, ref);
});
var IconCircle6 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber6, props, ref);
});
var IconCircle7 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber7, props, ref);
});
var IconCircle8 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber8, props, ref);
});
var IconCircle9 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleNumber9, props, ref);
});
var IconCircleCheck = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleCheck, props, ref);
});
var IconCircleCheckFilled = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleCheckFilled, props, ref);
});
var IconCircleMinus = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleMinus, props, ref);
});
var IconCirclePlus = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCirclePlus, props, ref);
});
var IconCircleX = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCircleX, props, ref);
});
var IconClock = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconClock, props, ref);
});
var IconCloud = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCloud, props, ref);
});
var IconCloudDownload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCloudDownload, props, ref);
});
var IconCloudOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCloudOff, props, ref);
});
var IconCloudUpload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCloudUpload, props, ref);
});
var IconCode = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCode, props, ref);
});
var IconCoin = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCoin, props, ref);
});
var IconCreditCard = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCreditCard, props, ref);
});
var IconCurrentLocation = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconCurrentLocation, props, ref);
});
var IconDeviceDesktop = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDeviceDesktop, props, ref);
});
var IconDeviceMobile = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDeviceMobile, props, ref);
});
var IconDeviceTablet = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDeviceTablet, props, ref);
});
var IconDots = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDots, props, ref);
});
var IconDotsVertical = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDotsVertical, props, ref);
});
var IconDownload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconDownload, props, ref);
});
var IconEdit = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconEdit, props, ref);
});
var IconExternalLink = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconExternalLink, props, ref);
});
var IconEye = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconEye, props, ref);
});
var IconEyeOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconEyeOff, props, ref);
});
var IconFile = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFile, props, ref);
});
var IconFileDownload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFileDownload, props, ref);
});
var IconFileExport = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFileExport, props, ref);
});
var IconFileImport = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFileImport, props, ref);
});
var IconFileSearch = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFileSearch, props, ref);
});
var IconFileUpload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFileUpload, props, ref);
});
var IconFiles = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFiles, props, ref);
});
var IconFilter = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFilter, props, ref);
});
var IconFingerprint = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFingerprint, props, ref);
});
var IconFlag = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFlag, props, ref);
});
var IconFolder = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFolder, props, ref);
});
var IconFolderOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFolderOff, props, ref);
});
var IconFolderPlus = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFolderPlus, props, ref);
});
var IconFolderX = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconFolderX, props, ref);
});
var IconH1 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH1, props, ref);
});
var IconH2 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH2, props, ref);
});
var IconH3 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH3, props, ref);
});
var IconH4 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH4, props, ref);
});
var IconH5 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH5, props, ref);
});
var IconH6 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconH6, props, ref);
});
var IconHash = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconHash, props, ref);
});
var IconHeart = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconHeart, props, ref);
});
var IconHelp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconHelp, props, ref);
});
var IconInbox = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconInbox, props, ref);
});
var IconInfoCircle = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconInfoCircle, props, ref);
});
var IconItalic = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconItalic, props, ref);
});
var IconLayout = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLayout, props, ref);
});
var IconLetterT = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLetterT, props, ref);
});
var IconLink = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLink, props, ref);
});
var IconList = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconList, props, ref);
});
var IconListNumbers = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconListNumbers, props, ref);
});
var IconLocation = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLocation, props, ref);
});
var IconLock = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLock, props, ref);
});
var IconLockOpen = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLockOpen, props, ref);
});
var IconLogin = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLogin, props, ref);
});
var IconLogout = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconLogout, props, ref);
});
var IconMail = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMail, props, ref);
});
var IconMailOpened = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMailOpened, props, ref);
});
var IconMap = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMap, props, ref);
});
var IconMapPin = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMapPin, props, ref);
});
var IconMarkdown = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMarkdown, props, ref);
});
var IconMenu2 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMenu2, props, ref);
});
var IconMessage = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMessage, props, ref);
});
var IconMicrophone = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMicrophone, props, ref);
});
var IconMicrophoneOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMicrophoneOff, props, ref);
});
var IconMusic = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconMusic, props, ref);
});
var IconPaperclip = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPaperclip, props, ref);
});
var IconPencil = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPencil, props, ref);
});
var IconPhone = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPhone, props, ref);
});
var IconPhoneIncoming = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPhoneIncoming, props, ref);
});
var IconPhoneOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPhoneOff, props, ref);
});
var IconPhoneOutgoing = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPhoneOutgoing, props, ref);
});
var IconPhoto = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPhoto, props, ref);
});
var IconPin = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPin, props, ref);
});
var IconPinnedOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPinnedOff, props, ref);
});
var IconPlayerPause = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerPause, props, ref);
});
var IconPlayerPlay = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerPlay, props, ref);
});
var IconPlayerRecord = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerRecord, props, ref);
});
var IconPlayerSkipBack = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerSkipBack, props, ref);
});
var IconPlayerSkipForward = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerSkipForward, props, ref);
});
var IconPlayerStop = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerStop, props, ref);
});
var IconPlayerTrackNext = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerTrackNext, props, ref);
});
var IconPlayerTrackPrev = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlayerTrackPrev, props, ref);
});
var IconPlus = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconPlus, props, ref);
});
var IconRadiusBottomLeft = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconRadiusBottomLeft, props, ref);
});
var IconRefresh = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconRefresh, props, ref);
});
var IconSearch = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconSearch, props, ref);
});
var IconSelector = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconSelector, props, ref);
});
var IconSend = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconSend, props, ref);
});
var IconSettings = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconSettings, props, ref);
});
var IconShare = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconShare, props, ref);
});
var IconShield = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconShield, props, ref);
});
var IconShoppingCart = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconShoppingCart, props, ref);
});
var IconSourceCode = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconSourceCode, props, ref);
});
var IconStar = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconStar, props, ref);
});
var IconStrikethrough = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconStrikethrough, props, ref);
});
var IconTag = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconTag, props, ref);
});
var IconThumbDown = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconThumbDown, props, ref);
});
var IconThumbUp = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconThumbUp, props, ref);
});
var IconTrash = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconTrash, props, ref);
});
var IconUnderline = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconUnderline, props, ref);
});
var IconUpload = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconUpload, props, ref);
});
var IconUser = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconUser, props, ref);
});
var IconUserCircle = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconUserCircle, props, ref);
});
var IconUsers = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconUsers, props, ref);
});
var IconVideo = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconVideo, props, ref);
});
var IconVideoOff = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconVideoOff, props, ref);
});
var IconVolume = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconVolume, props, ref);
});
var IconVolume2 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconVolume2, props, ref);
});
var IconVolume3 = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconVolume3, props, ref);
});
var IconWorld = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconWorld, props, ref);
});
var IconX = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconX, props, ref);
});
var IconZoomIn = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconZoomIn, props, ref);
});
var IconZoomOut = (0, _react1.forwardRef)(function(props, ref) {
    return withIcon(_iconsreact.IconZoomOut, props, ref);
});
